import { styled, ToggleButtonGroup } from "@mui/material";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => {
    return {
        borderRadius: theme.shape.borderRadius
    };
  });

  export default StyledToggleButtonGroup;